import { Method } from 'axios';
import { apiCall } from '@/utility/api/apiUtils';
import { API_METHOD_GET } from '@/constants/apiConstants';

// Types for the API response matching the provided structure
export interface Product {
  uuid: string;
  quote_id: string;
  section_id: string;
  product_id: string | null;
  supplier_id: string | null;
  item_type: number;
  item_code: string | null;
  manufacture_number: string | null;
  part_number: string | null;
  barcode: string | null;
  name: string;
  description: string;
  attachment_url: string | null;
  unit_cost: string;
  unit_price: string;
  quantity: number;
  total: string;
  display_order: number;
  markup: number;
  tax: number;
  discount: number;
}

export interface ColumnVisibility {
  product: boolean;
  qty: boolean;
  price: boolean;
  tax: boolean;
  discount: boolean;
  total: boolean;
}

export interface Section {
  uuid: string;
  title: string;
  description: string;
  section_type: number;
  display_order: number;
  is_active: boolean;
  is_approved: boolean;
  parent_section_id: string | null;
  column_visibility: ColumnVisibility;
  sections: Section[]; // Nested sections
  products: Product[];
  quote_labours: any[];
  quote_expenses: any[];
  quote_notes: any[];
  total_items: number;
  subtotal: number;
  cost: number;
  created_at: string;
  updated_at: string;
}

export interface Assigner {
  profile_pic: string;
  name: string;
  id: string;
}

export interface Task {
  id: string;
  desc: string;
  assigners: Assigner[];
}

export interface Phase {
  id: string;
  title: string;
  is_invoiced: boolean;
  has_quote: boolean;
  task: Task;
  sections: Section[];
}

export interface JobPhasesApiResponse {
  status: string;
  data: Phase[];
}

// API function to fetch job phases
export const fetchJobPhases = async (
  jobId: string,
): Promise<JobPhasesApiResponse> => {
  const method: Method = API_METHOD_GET;
  const url = `/v2/jobs/${jobId}/phases-for-invoices`;

  try {
    const response = await apiCall({
      method,
      url,
    });

    return response;
  } catch (error) {
    console.error('Error fetching job phases:', error);
    throw error;
  }
};
